/* 2026-09-16 (Claude) - Joel: "how can we have the price more obvious?", then picked option A.
   Puts the live price inside Add to Cart on products whose picker uses the option 5 media cards
   (.aoam-media-cards, the BitWhip Kit and Double BitWhip Kit) and on pill pickers of products tagged
   aoam-price-steps (LED Staff, Fiber Optic Costume Kit, Saber Kit), so the total is on the
   button at the moment of commit instead of ~1,200px up the page by the title.

   It does not compute a price. It MIRRORS the theme's own [data-product-price] element, which
   theme.js already rewrites on every variant change, so currency, markets and any price app
   (regios-dopp rewrites that element too) are respected for free. Linked from
   snippets/variant-button.liquid once per option, hence the run-once guard.
   Delete this file and its script tag in variant-button.liquid to roll back. */
(function () {
  if (window.AOAM_ATC_PRICE) return;
  window.AOAM_ATC_PRICE = true;

  function priceText(src) {
    var hidden = src.querySelector('.visually-hidden');
    return ((hidden ? hidden.textContent : src.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function wire(cards) {
    var input = cards.querySelector('input[form]');
    var formId = input && input.getAttribute('form');
    var form = formId && document.getElementById(formId);
    if (!form || form.getAttribute('data-aoam-atc-price')) return;
    var btn = form.querySelector('button[type="submit"][name="add"]') ||
      document.querySelector('button[type="submit"][name="add"][form="' + formId + '"]');
    if (!btn) return;
    var scope = form.closest('.product-single__meta, .product--single-content, .product-section, [data-section-id]') || document;
    var src = scope.querySelector('[data-product-price]') || document.querySelector('[data-product-price]');
    if (!src) return;
    form.setAttribute('data-aoam-atc-price', '1');

    var sep = document.createElement('span');
    sep.className = 'aoam-atc-price__sep';
    sep.setAttribute('aria-hidden', 'true');
    var out = document.createElement('span');
    out.className = 'aoam-atc-price';
    var icon = btn.querySelector('.icon-cart__small');
    btn.insertBefore(sep, icon || null);
    btn.insertBefore(out, icon || null);

    /* 2026-10-05 (Joel picked A): with add-ons ticked in this form's aoam-addons box, the button shows the
       running total from that box ([data-aoam-total-sum]) instead of the kit price, replacing the box's own
       total row (hidden by aoam-addon-cards.css). */
    var axBox = form.querySelector('.aoam-addons');
    var axSum = axBox && axBox.querySelector('[data-aoam-total-sum]');
    function sync() {
      var t = priceText(src);
      /* 2026-10-09 (Claude). Joel: "it should just add to the cart and not make it look like the price is more on the product". The button keeps the product price when add-ons are ticked. Roll back: restore the 10-05 line that copied [data-aoam-total-sum]. */
      if (out.textContent !== t) out.textContent = t;
      sep.hidden = out.hidden = !t;
    }
    sync();
    new MutationObserver(sync).observe(src, { childList: true, subtree: true, characterData: true });
    if (axSum) {
      new MutationObserver(sync).observe(axSum, { childList: true, subtree: true, characterData: true });
      form.addEventListener('change', function () { setTimeout(sync, 0); });
    }
  }

  function init() {
    /* .aoam-media-cards = BitWhip image cards; [data-aoam-price-steps] = pill pickers on products
       tagged aoam-price-steps (added 2026-09-16, "kits first"). */
    var all = document.querySelectorAll('.aoam-media-cards, [data-aoam-price-steps]');
    for (var i = 0; i < all.length; i++) wire(all[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
